import { Route, Routes } from "react-router-dom";
import BaseLayout from "./components/layout/BaseLayout";
import Appointment from "./pages/Appointment";
import AppRedirection from "./pages/AppRedirection";
import DeepLink from "./pages/bookingwidget/DeepLink";
import WaitlistClaimYourSlot from "./pages/bookingwidget/WaitlistClaimYourSlot";
import Login from "./pages/Login";
import LoginCallback from "./pages/LoginCallback";

// New pages (using CMS BookableItem data) - uncomment when ready to switch
// import ServiceSelection from "~/pages/bookingwidget/ServiceSelection";
// import StoreSelection from "./pages/bookingwidget/StoreSelection";
// import PathSelection from "./pages/bookingwidget/PathSelection";
// import CalendarSelection from "./pages/bookingwidget/CalendarSelection";
// import EnterDetails from "./pages/bookingwidget/EnterDetails";
// import BookingReview from "./pages/bookingwidget/BookingReview";
// import BookingConfirmation from "./pages/bookingwidget/BookingConfirmation";

// Old pages (using treatment variants data) - currently active
import StoreSelectionOld from "./pages/bookingwidget/StoreSelectionOld";
import ServiceSelectionOld from "./pages/bookingwidget/ServiceSelectionOld";
import CalendarSelectionOld from "./pages/bookingwidget/CalendarSelectionOld";
import EnterDetailsOld from "./pages/bookingwidget/EnterDetailsOld";
import BookingReviewOld from "./pages/bookingwidget/BookingReviewOld";
import BookingConfirmationOld from "./pages/bookingwidget/BookingConfirmationOld";
import StoreSelection from "./pages/bookingwidget/StoreSelection";
import PathSelection from "./pages/bookingwidget/PathSelection";
import ServiceSelection from "./pages/bookingwidget/ServiceSelection";
import CalendarSelection from "./pages/bookingwidget/CalendarSelection";
import EnterDetails from "./pages/bookingwidget/EnterDetails";
import BookingReview from "./pages/bookingwidget/BookingReview";
import BookingConfirmation from "./pages/bookingwidget/BookingConfirmation";
import KlarnaReturn from "./pages/bookingwidget/KlarnaReturn";
import KlarnaAuthorizationComplete from "./pages/bookingwidget/KlarnaAuthorizationComplete";
import BillingDraftPaymentPage from "./pages/billing-draft-payment/BillingDraftPaymentPage";

declare global {
    interface Window {
        dataLayer: any[];
    }
}

const App = () => {

    return (
        <Routes>
            <Route element={<BaseLayout />} path="/">
                <Route element={<AppRedirection />} path="/login-app" />

                {/* Customer login routes */}
                <Route element={<Login />} path="/login" />
                <Route element={<LoginCallback />} path="/login/callback" />

                <Route element={<DeepLink />} path="/deeplink/:slug" />
                <Route element={<WaitlistClaimYourSlot />} path="waitlist-claim-your-slot/:entryId" />

                {/* Old booking flow pages (using treatment variants) - currently active */}
                {/* <Route element={<StoreSelectionOld />} path="/" />
                <Route element={<ServiceSelectionOld />} path="services" />
                <Route element={<CalendarSelectionOld />} path="find-time" />
                <Route element={<EnterDetailsOld />} path="enter-details" />
                <Route element={<BookingReviewOld />} path="review-booking" />
                <Route element={<BookingConfirmationOld />} path="confirmation" /> */}

                {/* New booking flow pages (using CMS BookableItem data) - uncomment when ready to switch */}
                <Route element={<StoreSelection />} path="/" />
                <Route element={<PathSelection />} path="/select-path" />
                <Route element={<ServiceSelection />} path="services" />
                <Route element={<CalendarSelection />} path="find-time" />
                <Route element={<EnterDetails />} path="enter-details" />
                <Route element={<BookingReview />} path="review-booking" />
                <Route element={<KlarnaReturn />} path="klarna-return" />
                <Route element={<KlarnaAuthorizationComplete />} path="klarna-authorization-complete" />
                <Route element={<BookingConfirmation />} path="confirmation" />
               

                <Route element={<Appointment />} path="/appointment" />

                <Route element={<BillingDraftPaymentPage />} path="/pay/:token" />
            </Route>
        </Routes>
    )
};

export default App;
